import type { NavLink } from 'Components/Layout/DrawerMenu/types'
import BasicLayout from 'Components/Layout/Templates/BasicLayout'
import { isSuperuser } from 'Services/common/Features/User/userSlice'
import ProductRoot from 'Services/ProductManagement/Features/Product'
import SettingsRoot from 'Services/ProductManagement/Features/Settings'
import TariffRoot from 'Services/ProductManagement/Features/Tariff'
import useTypedSelector from 'Store'
import { LOGIN_PAGE_PATH, PRODUCT_MANAGEMENT_ROOT_URL } from 'Util/constants'
import ProtectedRoute from 'Util/ProtectedRoute'
import ConstructionIcon from '@mui/icons-material/Construction'
import EuroIcon from '@mui/icons-material/EuroSymbol'
import InventoryIcon from '@mui/icons-material/Inventory'
import { Navigate, Route, Routes } from 'react-router-dom'
import { t } from 'ttag'

function ProductManagement() {
  const { authed: isAuthed, user } = useTypedSelector(state => state.user)

  const menuBarNavLinks: NavLink[] = [
    {
      title: t`Tariffs`,
      link: `${PRODUCT_MANAGEMENT_ROOT_URL}/tariffs`,
      icon: <EuroIcon fontSize="small" />
    },
    {
      title: t`Products`,
      link: `${PRODUCT_MANAGEMENT_ROOT_URL}/products`,
      icon: <InventoryIcon fontSize="small" />
    },
    {
      title: t`Settings`,
      link: `${PRODUCT_MANAGEMENT_ROOT_URL}/settings`,
      icon: <ConstructionIcon fontSize="small" />
    }
  ]

  return (
    <Routes>
      <Route element={<BasicLayout menuBarNavLinks={menuBarNavLinks} />} path="/">
        <Route index element={<Navigate to="tariffs/" />} />
        <Route
          element={
            <ProtectedRoute
              isAuthenticated={isAuthed}
              isAllowed={isSuperuser(user)}
              authenticationPath={LOGIN_PAGE_PATH}
              restrictedPath={'/'}
            />
          }
          path="/products/*"
        >
          <Route path="*" element={<ProductRoot />} />
        </Route>
        <Route path="/tariffs/*" element={<TariffRoot />} />
        <Route
          element={
            <ProtectedRoute
              isAuthenticated={isAuthed}
              isAllowed={isSuperuser(user)}
              authenticationPath={LOGIN_PAGE_PATH}
              restrictedPath={'/'}
            />
          }
          path="/settings/*"
        >
          <Route path="*" element={<SettingsRoot />} />
        </Route>
      </Route>
    </Routes>
  )
}

export default ProductManagement
